export const ROUTE_PATHS = Object.freeze({
    LOGIN: '/',
    BIENVENIDA: '/Bienvenida',
    DASHBOARD: '/Dashboard',
    ADMINISTRADOR: '/Administrador',
    INSTALADORES: '/Instaladores',
    COTIZACIONES: '/Cotizaciones',
    CLIENTES: '/Prospectos',
    PROVEEDORES: '/Proveedores',
    MEMBRESIA_PAGO: '/CompraMembresia',
    CONFIGURACION: '/Configuraciones',
    FERRETERIA: '/Ferreteria',
    CONFIG_PROVEEDORES: '/ConfigProveedores',
    SITIO_CERRADO: '/SitioCerrado'
});